import { vnTemplate } from "@valnet/vnKnockoutJsTemplates/vnTemplate";
import { LpPageHeader } from "~/design-system";
export class menuPage_template extends vnTemplate {
    constructor(templateId, viewModel, caller, pageTitle) {
        super(templateId, viewModel, caller);
        this.pageTitle = pageTitle;
    }
    getTemplateHtml() {
        return /* html */ `
            ${LpPageHeader({
            title: this.pageTitle,
            description: "This page is not available yet.",
            icon: "folder-simple",
        })}

            <div class="menu-page-placeholder">
                <p class="menu-page-placeholder__text">This page is not available yet.</p>
            </div>
        `;
    }
    getTemplateName() {
        return "menuPage-template";
    }
    buildViewModel() {
        return {};
    }
}
